import axios from 'axios';
import { API_URL } from '../config';
import { getTokens } from '../utils/tokens';

export const instance = axios.create({
	baseURL: API_URL,
});

export const newInstance = axios.create({
	baseURL: API_URL,
});

newInstance.interceptors.request.use((config) => {
	const { token } = getTokens();

	config.headers.Authorization = `Bearer ${token}`;

	return config;
});
